import { set } from 'lodash';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_GET_FEATURE_FLIPPING_KEYS } from 'Utils/request/requestDictionary';
type Key = {
  key: string;
  value: boolean;
};
type Keys = Array<Key>;
type FeatureFlippingKeys = {
  featureFlippingKeys: {
    keys: Keys;
  };
};

const convertKeysToObject = (keys: Keys): CMSFeatureFlips =>
  keys.reduce((featureFlips, { key, value }) => set(featureFlips, key, value), {});

export const fetchFeatureFlippingKeys = async (
  appContext: AppContext,
): Promise<CMSFeatureFlips> => {
  const featureFlippingKeysQuery = `query {
    featureFlippingKeys {
      keys {
        key
        value
      }
    }
  }`;
  const { featureFlippingKeys } = await graphQLClient.runQuery<FeatureFlippingKeys>(
    featureFlippingKeysQuery,
    appContext,
    {
      requestName: CORE_GET_FEATURE_FLIPPING_KEYS,
    },
  );

  if (!featureFlippingKeys?.keys?.length) {
    return null;
  }

  return convertKeysToObject(featureFlippingKeys.keys);
};
